import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'

import contentLanguages from './contentLanguages.json'
import { getField, updateField } from 'vuex-map-fields'
import AccessControl from 'accesscontrol'
const ac = new AccessControl()

const formAppBarHeight = 60
const formAppBarHeightDense = 40

const isValidJson = (data, scope) => {
  try {
    JSON.parse(data)
  } catch (e) {
    console.log('JSON is broken', data, scope)
    return false
  }
  return true
}

Vue.use(Vuex)

const getFiltersForListRequest = (data) => {
  let filters = []
  if (data.fields && data.fields.includes('sortOrder')) {
    data.pagination.descending = false
    data.pagination.sortBy = ['sortOrder']
  }
  if (data.filters && data.filters.length > 0) {
    filters = data.filters
  }
  if (data.listFields) {
    filters.push({
      key: '_fields',
      value: data.listFields.join(',')
    })
  }
  if (data.searchFilters) {
    Object.keys(data.searchFilters).forEach(searchFilterName => {
      if (data.searchFilters[searchFilterName]) {
        filters.push({
          key: searchFilterName,
          value: data.searchFilters[searchFilterName]
        })
      }
    })
  }
  if (data.pagination) {
    Object.keys(data.pagination).forEach((paginationParam) => {
      let apiParam = paginationParam
      filters.push({
        key: apiParam,
        value: data.pagination[paginationParam]
      })
    })
  }
  return filters
}

export default new Vuex.Store({
  state: {
    selectedModuleName: '',
    searchClosedMobileMainList: true,
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    showMenu: false,
    showRightMenu: false,
    tenant: null,
    cs: {

    }, // confgSet
    apiBaseUrl: process.env.NODE_ENV === 'development'
      ? '/api/'
      : 'https://api-sandbox.costasolrent.com/api/',
    modules: {},
    modulesLoaded: false,
    authenticated: false,
    user: {},
    moduleListItems: {},
    moduleListItemsCount: {},
    moduleListLinkItems: {},
    translations: {},
    language: 'et',
    contentLanguages: contentLanguages,
    selectItems: {},
    selectItemsDisplayFields: {},
    searchFilters: {},
    draggedX: null,
    draggedY: null,
    draggingId: null,
    dragElOrigX: null,
    dragElOrigY: null,
    dragOrigWidth: null,
    dragOrigHeight: null,
    dragPlaceholderId: null,
    dragStartX: 0,
    dragStartY: 0,
    draggingIndex: null,
    showSnackbar: false,
    snackbarTimeout: 1000,
    snackbarColor: 'info',
    snackbarText: '',
    snackbarFreedTimestamp: null,
    grants: {
      current: {}
    },
    ac: ac
  },

  getters: {
    getField,
    user: state => state.user,
    showSnackbar: state => state.showSnackbar,
    snackbarTimeout: state => state.snackbarTimeout,
    snackbarColor: state => state.snackbarColor,
    snackbarText: state => state.snackbarText,
    modulesLoaded: state => state.modulesLoaded,
    modules: state => state.modules,
    contentLanguages: state => state.contentLanguages,
    selectItems: state => state.selectItems,
    selectItemsDisplayFields: state => state.selectItemsDisplayFields,
    moduleListItems: state => state.moduleListItems,
    moduleListItemsCount: state => state.moduleListItemsCount,
    moduleListLinkItems: state => state.moduleListLinkItems,
    moduleListLinkItemsCount: state => state.moduleListLinkItemsCount,
    translations: state => state.translations,
    language: state => state.language,
    authenticated: state => state.authenticated,
    searchFilters: state => state.searchFilters,
    draggedX: state => state.draggedX,
    draggedY: state => state.draggedY,
    draggingIndex: state => state.draggingIndex,
    adminTopLinks: state => state.moduleListItems && state.moduleListItems.adminTopLinks,
    objectStatesByModule: state => {
      let byModule = {}
      let objectStates = (state.moduleListItems && state.moduleListItems.objectStates) || []
      objectStates.forEach(objectState => {
        if (objectState.module) {
          if (!byModule[objectState.module]) { byModule[objectState.module] = [] }
          byModule[objectState.module].push(objectState)
        }
      })
      return byModule
    },
    formAppBarHeight: state => {
      return formAppBarHeight
    },
    formAppBarHeightDense: state => {
      return formAppBarHeightDense
    },
    ac: state => state.ac,
    pdfTemplatesByModule: state => {
      let byTemplate = {}
      if (state.moduleListItems && state.moduleListItems.pdfTemplates) {
        state.moduleListItems.pdfTemplates.forEach(pdfTemplate => {
          if (pdfTemplate && pdfTemplate.moduleRef) {
            if (!byTemplate[pdfTemplate.moduleRef.moduleName]) {
              byTemplate[pdfTemplate.moduleRef.moduleName] = []
            }
            byTemplate[pdfTemplate.moduleRef.moduleName].push(pdfTemplate)
          }
        })
      }
      return byTemplate
    }
  },

  actions: {

    toggleStateFilter: ({ state }, { moduleName, objectState }) => {
      let selectedStates = state.searchFilters[moduleName + '__states'] || []
      const selectedIndex = selectedStates.indexOf(objectState.id)
      if (selectedIndex !== -1) {
        selectedStates.splice(selectedIndex, 1)
      } else {
        selectedStates.push(objectState.id)
      }
      Vue.set(state.searchFilters, moduleName + '__states', JSON.parse(JSON.stringify(selectedStates)))
    },


    clearStateFilter: ({ state }, moduleName) => {
      Vue.set(state.searchFilters, moduleName + '__states', [])
    },

    showSnackbar: ({ state, dispatch }, { timeout, color, text }) => {
      // Snackbars in queue
      let delay = 100
      if (state.snackbarFreedTimestamp > +new Date) {
        const nextFreeTimeToShowSnackbar = state.snackbarFreedTimestamp
        delay = state.snackbarFreedTimestamp - +new Date
        state.snackbarFreedTimestamp = state.snackbarFreedTimestamp + timeout + 500
      } else {
        state.snackbarFreedTimestamp = +new Date + timeout + 500
      }
      setTimeout(() => {
        state.showSnackbar = false
        Vue.nextTick(() => {
          state.snackbarTimeout = timeout
          state.snackbarColor = color
          state.snackbarText = text
          state.showSnackbar = true
        })
      }, delay)
    },

    createModuleListItems: ({ state }) => {

      let moduleListItems = {}
      let moduleListItemsCount = {}
      let moduleListLinkItems = {}
      let moduleListLinkItemsCount = {}
      Object.keys(state.modules).forEach((moduleName) => {
        moduleListItems[moduleName] = []
        moduleListItemsCount[moduleName] = 0
        moduleListLinkItems[moduleName] = {}
        moduleListLinkItemsCount[moduleName] = {}
        Object.keys(state.modules[moduleName].fields).forEach((fieldName) => {
          if (['Link', 'MultiLink'].includes(state.modules[moduleName].fields[fieldName].type)) {
            let linkModuleName = state.modules[moduleName].fields[fieldName].linkModule
            moduleListLinkItems[moduleName][linkModuleName] = []
            moduleListLinkItemsCount[moduleName][linkModuleName] = null
          }
        })
      })
      state.moduleListItems = moduleListItems
      state.moduleListItemsCount = moduleListItemsCount
      state.moduleListLinkItems = moduleListLinkItems
      state.moduleListLinkItemsCount = moduleListLinkItemsCount
    },

    sortList: ({ state }, payload) => {
      let dragItemIndex = null
      let dragTargetIndex = null
      let upateSortOrderById = {}
      state.moduleListItems[payload.moduleName].forEach((item, index) => {
        if (item._id === payload.dragId) {
          dragItemIndex = index
        }
        if (item._id === payload.targetId) {
          dragTargetIndex = index
        }
      })
      // MOVE BACK
      if (dragItemIndex < dragTargetIndex) {
        // temp item
        let tempItem = JSON.parse(JSON.stringify(
          state.moduleListItems[payload.moduleName][dragItemIndex]
        ))
        let nextTargetSortOrder = tempItem.sortOrder

        for (let i = dragItemIndex + 1; i <= dragTargetIndex; i++) {
          let targetSortOrder = nextTargetSortOrder
          nextTargetSortOrder = state.moduleListItems[payload.moduleName][i].sortOrder
          if (!targetSortOrder) {
            targetSortOrder = i
          }
          if (nextTargetSortOrder < targetSortOrder || !nextTargetSortOrder) {
            nextTargetSortOrder = targetSortOrder + 1
          }
          // Apply new sort order
          Vue.set(state.moduleListItems[payload.moduleName][i], 'sortOrder',
            targetSortOrder
          )
          // Move 1 place to front
          Vue.set(state.moduleListItems[payload.moduleName], i - 1,
            JSON.parse(JSON.stringify(
              state.moduleListItems[payload.moduleName][i]
            ))
          )
          // Add to altered list
          let itemId = state.moduleListItems[payload.moduleName][i]._id
          upateSortOrderById[itemId] = targetSortOrder
        }
        // Finally move dragged item to target position

        let targetSortOrder = nextTargetSortOrder
        tempItem.sortOrder = targetSortOrder
        Vue.set(state.moduleListItems[payload.moduleName], dragTargetIndex,
          tempItem
        )
        upateSortOrderById[tempItem._id] = targetSortOrder
      } else if (dragItemIndex > dragTargetIndex) {
        // Move front
        // temp item
        let tempItem = JSON.parse(JSON.stringify(
          state.moduleListItems[payload.moduleName][dragItemIndex]
        ))
        let nextTargetSortOrder = tempItem.sortOrder

        for (let i = dragItemIndex - 1; i >= dragTargetIndex; i--) {
          let targetSortOrder = nextTargetSortOrder
          nextTargetSortOrder = state.moduleListItems[payload.moduleName][i].sortOrder
          if (!targetSortOrder) {
            targetSortOrder = i
          }
          if (nextTargetSortOrder > targetSortOrder || !nextTargetSortOrder) {
            nextTargetSortOrder = targetSortOrder - 1
          }
          // Apply new sort order
          Vue.set(state.moduleListItems[payload.moduleName][i], 'sortOrder',
            targetSortOrder
          )
          // Move 1 place to back
          Vue.set(state.moduleListItems[payload.moduleName], i + 1,
            JSON.parse(JSON.stringify(
              state.moduleListItems[payload.moduleName][i]
            ))
          )
          // Add to altered list
          let itemId = state.moduleListItems[payload.moduleName][i]._id
          upateSortOrderById[itemId] = targetSortOrder
        }
        // Finally move dragged item to target position

        let targetSortOrder = nextTargetSortOrder
        tempItem.sortOrder = targetSortOrder
        Vue.set(state.moduleListItems[payload.moduleName], dragTargetIndex,
          tempItem
        )
        upateSortOrderById[tempItem._id] = targetSortOrder
      }
      api.sortList(state.apiBaseUrl + state.tenant, payload.moduleName, upateSortOrderById)
    },

    getFilterOptions: ({ state }, data) => {
      return new Promise((resolve) => {
        let filters = []
        if (data.searchString) {
          filters.push({
            key: data.textField,
            value: data.searchString
          })
        }
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, data.moduleName, filters).then(result => {
          resolve(result.items)
        })
      })
    },

    login: ({ state, commit, dispatch }, data) => {
      return new Promise(resolve => {
        if (data.username && data.password && data.tenant) {
          state.tenant = data.tenant
          api.login(state.apiBaseUrl + state.tenant, data.username, data.password).then(response => {
            if (response.user && response.user._id) {
              state.authenticated = true
              state.user = response.user
              state.grants = {
                current: response.grants
              }
              state.ac.setGrants(state.grants)
              dispatch('loadSupportingData')
            } else {
              alert(response.error)
            }
            resolve()
          })
        }
      })
    },

    logout: ({ state, commit }) => {
      api.logout(state.apiBaseUrl + state.tenant).then(response => {
        commit('setKV', {
          k: 'authenticated',
          v: false
        })
        commit('setKV', {
          k: 'user',
          v: {}
        })
      })
    },

    checkAndShowErrors: ({ state, dispatch }, { result, request }) => {
      if (result.error) {
        let message = 'Error with ' + request
        if (result.usergroup === 'public') {
          message = 'Session error, relogin! ' + request
        }
        dispatch('showSnackbar', {
          timeout: 3000,
          text: message,
          color: 'error'
        })
      }
    },

    getModulesWithFields: ({ state, commit, dispatch }) => {
      return new Promise(resolve => {
        // Force sorting by sortOrder
        api.getModulesWithFields(state.apiBaseUrl + state.tenant).then((result) => {
          dispatch('checkAndShowErrors', {
            result: result,
            request: 'Get modulefields '
          })
          resolve(result)
        })
      })
    },

    getListItems: ({ state, commit, dispatch }, data) => {
      return new Promise(resolve => {
        let filters = getFiltersForListRequest(data)

        // Force sorting by sortOrder
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, data.moduleName, filters).then((result) => {
          dispatch('checkAndShowErrors', {
            result: result,
            request: 'Get list for ' + data.moduleName
          })
          resolve(result)
        })
      })
    },

    getListItemsToStore: ({ state, commit, dispatch }, data) => {
      return new Promise(resolve => {
        let filters = getFiltersForListRequest(data)

        // Force sorting by sortOrder
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, data.moduleName, filters).then((result) => {
          dispatch('checkAndShowErrors', {
            result: result,
            request: 'Get list to store ' + data.moduleName
          })
          resolve(result.items)
          commit('storeListItems', {
            moduleName: data.moduleName,
            items: result.items
          })
          commit('storeListItemsCount', {
            moduleName: data.moduleName,
            count: result.total
          })
        })
      })
    },

    getListReferenceItems: ({ state, commit }, data) => {
      let filters = getFiltersForListRequest(data)
      return new Promise(resolve => {
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, data.moduleName, filters)
          .then((result) => {
            resolve(result)
          })
      })
    },

    getLinkFieldListItems: ({ commit, state }, {
      moduleName,
      linkModuleDisplayField,
      searchInput,
      linkOptionsFilterField,
      linkOptionsFilterFieldValue,
      limit
    }) => {
      return new Promise((resolve) => {
        let filters = []
        let originalLinkModuleDisplayField = linkModuleDisplayField
        if (linkModuleDisplayField) {
          // If Virtual type, add virtual getters
          const linkFieldInfo = state.modules[moduleName].fields && state.modules[moduleName].fields[linkModuleDisplayField]
          if (linkFieldInfo && linkFieldInfo.type === 'Virtual') {
            if (linkModuleDisplayField &&
              state.modules[moduleName] &&
              state.modules[moduleName].fields &&
              state.modules[moduleName].fields[linkModuleDisplayField] &&
              state.modules[moduleName].fields[linkModuleDisplayField].getters
            ) {
              linkModuleDisplayField += ',' + state.modules[moduleName].fields[linkModuleDisplayField]
                .getters.filter(getter => getter.field).map(getter => {
                  // Split with _ as _lang is not needed, api includes all translations
                  // AND field name should not include _ in it
                  // TODO !!! validatoin for module field name not to include '_' !
                  return getter.field.split('_')[0]
                }).join(',')
            }
          }
          // Multilingual
          // if (linkFieldInfo && linkFieldInfo.multilingual) {
          //   linkModuleDisplayField += '_' + state.language
          //   if (linkFieldInfo.multilingual !== 'en') {
          //     linkModuleDisplayField += ',' + linkModuleDisplayField + '_en'
          //   }
          // }
          filters.push({
            key: '_fields',
            value: linkModuleDisplayField
          })
          if (searchInput) {
            filters.push({
              key: originalLinkModuleDisplayField,
              value: searchInput
            })
          }
          // linkOptionsFilterField
          if (linkOptionsFilterField && linkOptionsFilterFieldValue) {
            filters.push({
              key: linkOptionsFilterField,
              value: linkOptionsFilterFieldValue
            })
          }
        }
        console.log('filters', filters)
        filters.push({
          key: 'rowsPerPage',
          value: limit || 100
        })
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, moduleName, filters)
          .then((items) => {
            resolve(items)
          })
      })
    },

    saveItem: ({ commit, state, dispatch }, payload) => {
      return new Promise(resolve => {
        api.saveItem(state.apiBaseUrl + state.tenant, payload.moduleName, payload.data).then(result => {
          dispatch('checkAndShowErrors', {
            result: result,
            request: 'Save ' + payload.moduleName
          })
          resolve(result)
        })
      })
    },

    getLinkFieldOptions: ({ state, commit, dispatch }, moduleName) => {
      return new Promise((resolve) => {
        let promises = []
        let linkModuleNames = []
        Object.keys(state.modules[moduleName].fields).forEach((fieldName) => {
          let fieldInfo = state.modules[moduleName].fields[fieldName]
          // Don't download twice
          const alreadyDownloaded = (state.moduleListLinkItems &&
            state.moduleListLinkItems[moduleName] &&
            state.moduleListLinkItems[moduleName][fieldInfo.linkModule] &&
            state.moduleListLinkItems[moduleName][fieldInfo.linkModule].length > 0)
          if (!alreadyDownloaded && ['Link', 'MultiLink'].includes(fieldInfo.type)) {
            promises.push(dispatch('getLinkFieldListItems', {
              moduleName: fieldInfo.linkModule,
              linkModuleDisplayField: fieldInfo.linkModuleDisplayField
            }))
            linkModuleNames.push(fieldInfo.linkModule)
          }
        })
        // Add features, later to somewhere else
        if (state.modules[moduleName].loadFeatures) {
          promises.push(dispatch('getLinkFieldListItems', {
            moduleName: state.modules[moduleName].featuresModuleName,
            limit: 500
          }))
          linkModuleNames.push(state.modules[moduleName].featuresModuleName)
        }
        Promise.all(promises).then((values) => {
          linkModuleNames.forEach((linkModuleName, i) => {
            commit('storeListLinkItems', {
              moduleName: moduleName,
              linkModuleName: linkModuleName,
              items: values[i].items,
              total: values[i].total
            })
          })
          resolve([])
        })
      })
    },

    restoreSession: ({ dispatch, state, getters }) => {
      api.checkSession(state.apiBaseUrl + state.tenant).then(result => {
        if (result.user) {
          state.authenticated = true
          state.user = result.user
          state.grants = {
            current: result.grants
          }
          state.tenant = result.tenant
          state.ac.setGrants(state.grants)
          dispatch('loadSupportingData')
        }
      })
    },

    loadSupportingData: ({ dispatch }) => {
      dispatch('getModules').then(() => {
        dispatch('getObjectStates')
        dispatch('getPdfTemplates')
        dispatch('getConfigSet')
        //dispatch('getTranslations')
        //dispatch('getUnits')
        dispatch('getAdminTopLinks')
        dispatch('getMenuGroups')
      })
    },

    getTranslations: ({ commit, state, dispatch }) => {
      return new Promise(resolve => {
        api.getListItemsToStore(state.apiBaseUrl + state.tenant, 'translations', [{
          key: 'rowsPerPage',
          value: '1000'
        }]).then(result => {
          let translations = {}
          if (result.items) {
            result.items.forEach((item) => {
              let language = item.languageRef.languageCode
              let module = item.moduleRef && item.moduleRef.moduleName
              // if (!module) { return }
              if (!translations[language]) {
                translations[language] = {}
              }
              if (!translations[language][module]) {
                translations[language][module] = {}
              }
              translations[language][module][item.fieldName] = item.translation
            })
          }
          commit('storeTranslations', translations)
          dispatch('checkAndShowErrors', {
            result: result,
            request: 'Get translations'
          })
          resolve(result)
        })
      })
    },

    getUnits: ({ dispatch }) => {
      dispatch('getListItemsToStore', {
        moduleName: 'units'
      })
    },

    getAdminTopLinks: ({ dispatch }) => {
      dispatch('getListItemsToStore', {
        moduleName: 'adminTopLinks',
        filters: [{ key: 'sortBy', value: 'sortOrder' }]
      })
    },

    getObjectStates: ({ dispatch }) => {
      dispatch('getListItemsToStore', {
        moduleName: 'objectStates',
        filters: [{ key: 'sortBy', value: 'sortOrder' }]
      })
    },

    getConfigSet: ({ state }) => {
      api.getListItemsToStore(state.apiBaseUrl + state.tenant, 'configSets', [])
        .then((result) => {
          if (result && result.items && result.items[0]) {
            state.cs = result.items[0]
          }
        })
    },

    getPdfTemplates: ({ dispatch }) => {
      dispatch('getListItemsToStore', {
        moduleName: 'pdfTemplates'
      })
    },

    getMenuGroups: ({ dispatch }) => {
      dispatch('getListItemsToStore', {
        moduleName: 'menuGroups'
      }).then(result => {
        // console.log('DONE', result)
      })
    },

    getModules: ({ state, dispatch, commit }) => {
      let modules = {}
      return new Promise(resolve => {
        dispatch('getListItems', {
          moduleName: 'modules'
        }).then(modulesResult => {
          if (!modulesResult || !modulesResult.items) {
            resolve(false)
            return
          }
          modulesResult.items.forEach(module => {
            modules[module.moduleName] = module
            modules[module.moduleName].fields = {}
            modules[module.moduleName].tabs = {}
          })

          dispatch('getListItems', {
            moduleName: 'moduleTabs',
            filters: [{
              key: 'rowsPerPage',
              value: '1000'
            }]
          }).then(tabsResponse => {

            tabsResponse.items.forEach(tab => {
              if (tab.module && tab.module.moduleName && modules[tab.module.moduleName]) {
                modules[tab.module.moduleName].tabs[tab.tabName] = tab
              }
            })

            dispatch('getModulesWithFields').then(modules => {

              // fieldsResult.items.forEach(field => {
              //   let combinedProps = field
              //   combinedProps.type = field.moduleFieldType && field.moduleFieldType.typeName || null
              //   combinedProps.listHide = !field.listShow
              //   if (field.listFilter && !field.filterType) {
              //     field.filterType = "Text"
              //   }
              //   if (field.config && isValidJson(field.config, field)) {
              //     let configProps = JSON.parse(field.config)
              //     Object.keys(configProps).forEach(key => {
              //       combinedProps[key] = configProps[key]
              //     })
              //   }
              //   if (field && field.module && field.module.moduleName && modules[field.module.moduleName]) {
              //     modules[field.module.moduleName].fields[field.fieldName] = combinedProps
              //   }
              // })

              // Object.keys(modules).forEach(moduleName => {
              //   Object.keys(modules[moduleName].fields).forEach(fieldName => {
              //     let field = modules[moduleName].fields[fieldName]
              //     console.log(fieldName, field)
              //   })
              // })

              state.modules = JSON.parse(JSON.stringify(modules))
              state.modulesLoaded = true

              dispatch('createModuleListItems')

              commit('storeListItems', {
                moduleName: 'modules',
                items: modulesResult.items
              })
              commit('storeListItemsCount', {
                moduleName: 'modules',
                count: modulesResult.total
              })

              resolve(true)
            })
          })
        })
      })
    }
  },

  mutations: {
    updateField,

    toggleBooleanValue: (state, payload) => {
      if (state.moduleListItems[payload.moduleName] &&
        state.moduleListItems[payload.moduleName][payload.index]
      ) {
        Vue.set(state.moduleListItems[payload.moduleName][payload.index],
          payload.fieldName,
          !state.moduleListItems[payload.moduleName][payload.index][payload.fieldName]
        )
      }
    },

    storeListItems: (state, payload) => {
      if (payload.moduleName) {
        let moduleListItems = state.moduleListItems
        moduleListItems[payload.moduleName] = payload.items
        Vue.set(state, 'moduleListItems', moduleListItems)
      }
    },

    storeListItemsCount: (state, payload) => {
      if (payload.moduleName) {
        let moduleListItemsCount = state.moduleListItemsCount
        moduleListItemsCount[payload.moduleName] = payload.count
        Vue.set(state, 'moduleListItemsCount', moduleListItemsCount)
      }
    },

    storeListLinkItems: (state, payload) => {
      if (payload.moduleName) {
        let moduleListLinkItems = state.moduleListLinkItems
        moduleListLinkItems[payload.moduleName][payload.linkModuleName] = payload.items
        let moduleListLinkItemsCount = state.moduleListLinkItemsCount
        moduleListLinkItemsCount[payload.moduleName][payload.linkModuleName] = payload.total
        Vue.set(state, 'moduleListLinkItems', moduleListLinkItems)
        Vue.set(state, 'moduleListLinkItemsCount', moduleListLinkItemsCount)
      }
    },

    setKV: (state, data) => {
      Vue.set(state, data.k, data.v)
    },

    setSelectItemsDisplayFields: (state, data) => {
      Vue.set(state.selectItemsDisplayFields, data.k, data.v)
    },

    setSelectItems: (state, data) => {
      Vue.set(state.selectItems, data.k, data.v)
    },

    setSearchFilters: (state, data) => {
      Vue.set(state.searchFilters, data.k, data.v)
    },

    storeTranslations: (state, translations) => {
      Vue.set(state, 'translations', translations)
    }
  }
})
